



























































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import WorkshopsWorkshopDetails from "../workshops/WorkshopsWorkshopDetails.vue";

import WorkshopJson from "../../shared/WorkshopJson";

import { UserPermissionRank } from "../../shared/UserPermissionRank";

export default Vue.extend({
  name: "WorkshopsWorkshops",
  components: {
    Loading,
    WorkshopsWorkshopDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      showDetails: false,
      detailsMode: "read",
      allWorkshops: null as WorkshopJson[] | null,
      selectedWorkshopId: null as number | null,
      selectedWorkshop: null as WorkshopJson | null,
      showOldWorkshops: false as boolean,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.loadData();
      }
    },

    loadData() {
      this.loadWorkshops();
    },

    async reloadSelectedWorkshop() {
      this.selectedWorkshop = null;
      this.toggleDetails();
      if (this.selectedWorkshopId != null) {
        try {
          this.allWorkshops = await this.restClient.getWorkshops();

          //todo: selectedWorkshop filtern
          this.openDetails(this.selectedWorkshop, "read");
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadWorkshops() {
      this.allWorkshops = null;
      if (this.restClient != null) {
        try {
          this.allWorkshops = await this.restClient.getWorkshops();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    getWorkshopStatus(item: WorkshopJson) {
      if (item.allowRegistration) {
        let today = new Date();

        if (today < new Date(item.registrationBeginDateTime)) {
          return "Freigegeben und buchbar ab " + DateFormatter.formatDateTime(new Date(item.registrationBeginDateTime));
        } else if (today > new Date(item.registrationEndDateTime)) {
          return "Buchungszeitraum abgelaufen";
        } else {
          return "Freigegeben zur Buchung";
        }
      } else {
        return "Nicht freigegeben";
      }
    },

    openDetails(item: WorkshopJson | null, mode: string) {
      if (item != null) {
        this.selectedWorkshopId = item.ID;
        this.selectedWorkshop = JSON.parse(JSON.stringify(item));
      } else {
        this.selectedWorkshopId = null;
        this.selectedWorkshop = null;
      }

      this.detailsMode = mode;
      this.toggleDetails();
    },

    async duplicateWorkshop(item: WorkshopJson) {
      let newItem: WorkshopJson = JSON.parse(JSON.stringify(item));

      this.allWorkshops = null;

      newItem.ID = null;
      newItem.title = newItem.title + " Kopie";
      newItem.allowRegistration = false;

      try {
        let duplicatedWorkshop = await this.restClient.addWorkshop(newItem);
      } catch (e) {
        alert(e.message);
      }

      this.loadWorkshops();
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    filteredWorkshops(): WorkshopJson[] | null {
      if (this.allWorkshops != null && !this.showOldWorkshops) {
        let today = new Date();
        let filtered = this.allWorkshops.filter((i: any) => new Date(i.dates[i.dates.length - 1].endDateTime) > today);

        return filtered;
      } else {
        return this.allWorkshops;
      }
    },
  },
});
